// Overland Trailers — off-road expedition trailer imagery.
//
// Iteration 109: Owner-approved overland trailer photography landed via
// the canonical manifest (see /lib/photos/manifest.js).  This module now
// only exposes true overland expedition trailer imagery.  The previous
// Newell / Prevost / trailer-master stand-ins have been retired.
import { _ASSET_BASE } from "./_base";

const OT_HERO    = `${_ASSET_BASE}/5r8dbo5p_IMG_5605.jpeg`; // dark grey pop-top · beach + shipwreck
const OT_ACCENT  = `${_ASSET_BASE}/hpmhyviw_IMG_5606.jpeg`; // Bruder EXP-8 · military green · beach
const OT_GALLERY_1 = `${_ASSET_BASE}/fb5i2zl6_IMG_5607.jpeg`; // iKamper teardrop · mountain camp
const OT_GALLERY_2 = `${_ASSET_BASE}/pp1h7anm_IMG_5608.jpeg`; // Boreas EOS-12 · desert

export const OVERLAND_TRAILER_PHOTOS = [
  OT_HERO,
  OT_ACCENT,
  OT_GALLERY_1,
  OT_GALLERY_2,
];

const overlandTrailers = {
  hero: OT_HERO,
  accent: OT_ACCENT,
  gallery: [OT_GALLERY_1, OT_GALLERY_2],
  card: OT_HERO,
  social: OT_HERO,
};
export default overlandTrailers;
